<div class="with-floating-button">
    <div class="content">
        <page-header [title]="'admin.maintenance.compteAdmin.onglets.compteAdmin' | translate" [listeItems]="listeTabItems">
        </page-header>

        <change-password></change-password>
    </div>
</div>
